import React, { useCallback, useEffect } from 'react';
import { Button, Col, Form, Input, Row } from "antd";
import { CloseOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Contact } from "../../../../models/chemicalization/company";
import { useTranslation } from "react-i18next";

interface IProps {
  setContacts: (contacts: Contact[]) => void;
  contacts: Contact[] | null;
}

export const ContactItems: React.FC<IProps> = ({ setContacts, contacts }) => {
  const { t } = useTranslation();
  const [ contactItems, setContactItems ] = React.useState<Contact[]>([]);

  // Функция для генерации уникального ключа
  const generateUniqueKey = (): number => {
	return Math.random();
  };

  // Создание нового элемента с уникальным ключом
  const createNewItem = (): Contact => ({
	key: generateUniqueKey(),
	id: null,
	contactName: null,
	phone: null,
	email: null,
	company: null
  });

  useEffect(() => {
	if (contacts && contacts.length > 0) {
	  const itemsWithKeys = contacts.map((item) => ({
		...item,
		key: item.key || generateUniqueKey(),
	  }));
	  setContactItems(itemsWithKeys);
	} else {
	  setContactItems([createNewItem()]);
	}
  }, []);

  useEffect(() => {
	setContacts(contactItems);
  }, [contactItems]);

  const handleAddItem = useCallback(() => {
	setContactItems((prevItems) => [...prevItems, createNewItem()]);
  }, []);

  const handleDeleteItem = useCallback(
	(key: number) => {
	  if (contactItems.length > 1) {
		const updatedItems = contactItems.filter((item) => item.key !== key);
		setContactItems(updatedItems);
		setContacts(updatedItems);
	  }
	},
	[contactItems, setContacts]
  );

  const handleInputChange = (
	key: number,
	field: keyof Contact,
	value: any
  ) => {
	const updatedContacts = contactItems.map((item) =>
	  item.key === key ? { ...item, [field]: value } : item
	);
	setContactItems(updatedContacts);
	setContacts(updatedContacts);
  };

  const isFieldEmpty = (value: any) => {
	return value === null || value === undefined || value === "";
  };

  return (
	<div style={ { marginTop: 15 } }>
	  <label>{ t("user.contacts") }</label>
	  { contactItems.map((item) => (
		<div key={ item.id } className="block_item_form massive_blocks">
		  <Button
			type="primary"
			className="fixed_delete"
			danger
			icon={ <CloseOutlined/> }
			shape="circle"
			size="small"
			disabled={ contactItems.length === 1 }
			onClick={ () => handleDeleteItem(item.key as number) }
		  />
		  <Row key={ item.id } gutter={ 12 } align="middle">
			<Col span={ 8 }>
			  <Form.Item
				label={ t("user.full_name") }
				rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
			  >
				<Input
				  className={isFieldEmpty(item.contactName) ? "error-border" : ""}
				  value={ item.contactName || "" }
				  onChange={ (e) =>
					handleInputChange(item.key as number, "contactName",e.target.value)
				  }
				/>
			  </Form.Item>
			</Col>
			<Col span={ 8 }>
			  <Form.Item
				label={ t("user.phone_number") }
				rules={ [
				  { required: true, message: t("msg.fill_in_the_field") },
				  { pattern: /^996\d{9}$/, message: t('user.phone_number_desc') },
				] }
			  >
				<Input
				  type="number"
				  className={isFieldEmpty(item.phone) ? "error-border" : ""}
				  value={ item.phone || "" }
				  onChange={ (e) =>
					handleInputChange(item.key as number, "phone", Number(e.target.value))
				  }
				  placeholder="996777000000"
				  maxLength={ 12 }
				/>
			  </Form.Item>
			</Col>
			<Col span={ 8 }>
			  <Form.Item
				label={ t("user.email") }
				rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
			  >
				<Input
				  className={isFieldEmpty(item.email) ? "error-border" : ""}
				  value={ item.email || "" }
				  onChange={ (e) =>
					handleInputChange(item.key as number, "email", e.target.value)
				  }
				  type="email"
				/>
			  </Form.Item>
			</Col>
		  </Row>
		</div>
	  )) }
	  <Button
		style={ { marginTop: 15 } }
		icon={ <PlusCircleOutlined/> }
		type="primary"
		onClick={ handleAddItem }
	  >
		{ t("Добавить еще элемент") }
	  </Button>
	</div>
  );
};

